export const SUBMITTED = "Submitted";
export const CONTACTING = "Contacting";
export const CONTACTED = "Contacted";
export const CONTACTED_DISPLAY_NAME = "Follow up Scheduled";
export const QUALIFIED = "Qualified";